import type { EntryRestrictions } from './entry-restrictions.model';

export interface GenerateEntryRestrictionsOptions {
  readonly userId: number;
  readonly contestId: number;
  readonly requirements?:
    | {
        readonly complete: true;
        readonly isAtoSerrRequirementMet: boolean;
      }
    | {
        readonly complete: false;
        readonly isAtoSerrRequirementMet: boolean;
        readonly profile: {
          readonly hasFullname: boolean;
          readonly hasAddress: boolean;
          readonly hasProfilePicture: boolean;
          readonly displayName: string;
          readonly username: string;
        };
        readonly trust: {
          readonly hasVerifiedEmail: boolean;
          readonly hasVerifiedPhone: boolean;
          readonly hasFacebook: boolean;
          readonly hasLinkedIn: boolean;
          readonly hasVerifiedCard: boolean;
          readonly isKycVerified: boolean;
          readonly minimumRequired: number;
          readonly points: {
            readonly email: number;
            readonly phone: number;
            readonly ccv: number;
            readonly kyc: number;
            readonly facebook: number;
            readonly linkedin: number;
          };
          readonly score: number;
          readonly targetPoints: number;
          readonly showCcv: boolean;
        };
      };
}

export function generateEntryRestrictionsObject({
  userId,
  contestId,
  requirements = { complete: true, isAtoSerrRequirementMet: true },
}: GenerateEntryRestrictionsOptions): EntryRestrictions {
  const id = `${userId}_${contestId}`;

  // TypeScript needs this to be sure both cases are covered, for some reason
  if (requirements.complete) {
    return {
      id,
      requirements,
    };
  }

  return {
    id,
    requirements,
  };
}

// --- Mixins ---

export function incompleteEntryRequirements(): Pick<
  GenerateEntryRestrictionsOptions,
  'requirements'
> {
  return {
    requirements: {
      complete: false,
      isAtoSerrRequirementMet: true,
      profile: {
        hasFullname: true,
        hasAddress: false,
        hasProfilePicture: false,
        displayName: 'Test Name',
        username: 'testUsername',
      },
      trust: {
        hasVerifiedEmail: false,
        hasVerifiedPhone: false,
        hasFacebook: true,
        hasLinkedIn: false,
        hasVerifiedCard: false,
        isKycVerified: false,
        minimumRequired: 35,
        points: {
          email: 5,
          phone: 10,
          ccv: 45,
          kyc: 35,
          facebook: 20,
          linkedin: 20,
        },
        score: 5,
        targetPoints: 30,
        showCcv: true,
      },
    },
  };
}

export function incompleteAtoSerrEntryRequirements(): Pick<
  GenerateEntryRestrictionsOptions,
  'requirements'
> {
  return {
    requirements: {
      complete: true,
      isAtoSerrRequirementMet: false,
    },
  };
}
